<template>
    <div class="c-app">
        <TheSidebar/>
        <CWrapper>
            <TheHeader 
                :notifications="notifications" 
                :numNotifications="numNotifications"
            />
            <div class="c-body">
                <main class="c-main">
                    <CContainer fluid>
                        <transition name="fade">
                            <router-view></router-view>
                        </transition>
                    </CContainer>
                </main>
                <TheFooter/>
            </div>
        </CWrapper>
    </div>
</template>

<script>
import axios from 'axios';
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'

export default {
    name: 'TheContainer',
    components: {
        TheSidebar,
        TheHeader,
        TheFooter
    },
    data() {
        return {
            notifications: [],
            numNotifications: 0
        }
    },
    mounted() {
        this.getNotifications();
        setInterval(this.getNotifications, 600000);
    },
    methods: {
        getUrl(id) {
            return `/orders/${id}/edit`;
        },
        getNotifications() {
            axios.get('/api/notifications?token=' + localStorage.getItem("api_token"))
                .then(response => {
                    this.notifications = response.data;
                    this.numNotifications = this.notifications.length;
                }).catch(error => {
                    console.error(error);
                });
        }
    }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
